import { CustomPreloader } from '../CustomPreloader'
import { PreloaderWrapper } from './SuspenseFallback.styled'

export const SuspenseFallback = () => {
  return (
    <PreloaderWrapper>
      <CustomPreloader />
    </PreloaderWrapper>
  )
}
